import {
  GET_ALL_USERS,
  GET_USER,
  GET_TEAM_USER,
  RESET_USER,
  GET_USERS_TASK_ARE_ASSIGNED_TO,
  GET_PROFILE_IMAGE,
  GET_USERS_FOR_DROPDOWN,
  GET_PROFILE_IMAGE_CURRENT_USER,
  GET_TEAMUSER_PROFILE_IMAGE,
  RESET_TEAMUSER,
  GET_USERS_SIGNATURE,
  SET_USER_SIGNATURE,
  RESET_SIGNATURE,
  GET_USERS_EXPECTATIONS,
  CHANGE_USERS_EXPECTATIONS,
  SET_USERS_FOR_CUSTOM_SELECT,
  GET_USER_RATING,
  GET_USERS_FOR_SELECT,
  GET_MY_TEAM,
  GET_USER_OPTIONS,
  UPDATE_USER_OPTIONS,
} from './types'

const initialState = {
  users: [],
  user: {},
  myTeam: [],
  teamUser: {},
  loading: false,
  profileImgUrl: null,
  profileImgUrlCurrent: null,
  userSignature: {},
  usersForDropDown: [],
  userRating: {},
  usersForSelect: [],
  userOptions: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USERS_FOR_SELECT:
      return {
        ...state,
        usersForSelect: action.payload,
      }
    case GET_USERS_TASK_ARE_ASSIGNED_TO:
      return {
        ...state,
        users: action.payload,
      }
    case GET_USER:
      return {
        ...state,
        user: action.payload,
      }
    case GET_MY_TEAM:
      return {
        ...state,
        myTeam: action.payload,
      }
    case GET_TEAM_USER:
      return {
        ...state,
        teamUser: action.payload,
      }
    case GET_ALL_USERS:
      return {
        ...state,
        users: action.payload,
      }
    case RESET_USER:
      return {
        ...state,
        user: action.payload,
      }
    case GET_PROFILE_IMAGE:
      return {
        ...state,
        user: { ...state.user, profileImgUrl: action.payload },
      }
    case GET_TEAMUSER_PROFILE_IMAGE:
      return {
        ...state,
        teamUser: { ...state.teamUser, profileImgUrl: action.payload },
      }
    case RESET_TEAMUSER:
      return {
        ...state,
        teamUser: action.payload,
      }
    case GET_PROFILE_IMAGE_CURRENT_USER:
      return {
        ...state,
        profileImgUrlCurrent: action.payload,
      }
    case GET_USERS_SIGNATURE:
      return {
        ...state,
        userSignature: action.payload,
      }
    case SET_USER_SIGNATURE:
      return {
        ...state,
        userSignature: action.payload,
      }
    case RESET_SIGNATURE:
      return {
        ...state,
        userSignature: {},
      }
    case GET_USERS_FOR_DROPDOWN:
      return {
        ...state,
        usersForDropDown: action.payload,
      }
    case GET_USERS_EXPECTATIONS:
      return {
        ...state,
        usersExpectations: action.payload,
      }
    case SET_USERS_FOR_CUSTOM_SELECT:
      return {
        ...state,
        usersForCustomSelect: action.payload,
      }
    case CHANGE_USERS_EXPECTATIONS:
      return {
        ...state,
        usersExpectations: { ...state.usersExpectations, ...action.payload },
      }
    case GET_USER_RATING:
      return {
        ...state,
        userRating: { ...action.payload },
      }
    case GET_USER_OPTIONS:
      return {
        ...state,
        userOptions: action.payload,
      }
    case UPDATE_USER_OPTIONS:
      return {
        ...state,
        userOptions: action.payload,
      }
    default:
      return state
  }
}
